const FEATURES = [
  {
    icon: 'ri-database-2-line',
    title: '全面资源展示',
    desc: '汇聚电影、电视剧、综艺三大板块，标题、封面、主创与简介信息一目了然。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '高效内容检索',
    desc: '支持名称与标签关键词的模糊搜索，配合年份、地区与题材多维筛选快速定位。',
  },
  {
    icon: 'ri-heart-3-line',
    title: '本地收藏管理',
    desc: '一键收藏感兴趣的内容，收藏状态保存在浏览器本地，随时回顾心愿片单。',
  },
  {
    icon: 'ri-share-line',
    title: '便捷分享导航',
    desc: '复制详情页链接即可与好友分享，帮助你更快做出观看决策。',
  },
];

const STATS = [
  { value: '24+', label: '影视条目' },
  { value: '3', label: '内容板块' },
  { value: '18', label: '题材标签' },
  { value: '每日', label: '持续更新' },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 md:px-8 mt-10 md:mt-14">
      <div className="rounded-lg bg-gradient-to-br from-primary-900 to-primary-700 text-background-50 p-6 md:p-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/15 text-xs font-medium">
              <i className="ri-film-line"></i>
              关于神马视频
            </span>
            <h2 className="mt-4 text-2xl md:text-3xl font-bold leading-tight">
              多元影视内容平台<br className="hidden md:block" />
              让查找与了解更简单
            </h2>
            <p className="mt-4 text-sm md:text-base text-background-200 leading-relaxed">
              神马视频是集最新电影、电视剧、综艺节目资源于一体的多元影视内容平台，专注为影视爱好者提供全面的资源展示与信息导航。我们帮助你快速查找、浏览并了解影视内容信息，提升观看决策效率。
            </p>
            <p className="mt-3 text-sm text-background-300">
              请注意：本站仅做资源展示及信息导航，不直接承担视频播放或下载服务。
            </p>
            <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {STATS.map((stat) => (
                <div key={stat.label}>
                  <p className="text-xl md:text-2xl font-bold text-accent-400">{stat.value}</p>
                  <p className="mt-1 text-xs text-background-300">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {FEATURES.map((feature) => (
              <div
                key={feature.title}
                className="rounded-lg bg-background-50/10 border border-background-50/15 p-4 md:p-5"
              >
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-primary-950">
                  <i className={`${feature.icon} text-xl`}></i>
                </span>
                <h3 className="mt-3 text-sm md:text-base font-semibold text-background-50">{feature.title}</h3>
                <p className="mt-1.5 text-xs md:text-sm text-background-300 leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}